/**
 * :: USAGE ::
 *
 * "subPath" is NOT expected to use on component level since it is not a full path
 * "path" is expected to use for page navigation on component level if there is no additional param to resolve
 * "pathResolver" is expected to use when the url needs to combine with some additional params
 * "canonicalPathResolver" is expected for SEO indexed page only
 * "alternatePaths" is expected to use as possible alternate path options for the page
 *
 */

const domesticReservationIdExp = 'RYa[0-9a-zA-Z]{1,10}.*'; // need to confirm the exact regex for reservation ID

const paths = {
  top: {
    path: '/',
    pathResolver: () => `/`,
    canonicalPathResolver: () => `/`,
  },
  detail: {
    path: `/detail/:reservationId(${domesticReservationIdExp})`,
    pathResolver: (reservationId: string) => `/detail/${reservationId}`,
  },
};

export default paths;
